import React, { useEffect, useRef } from 'react'

const useClickOutside = (callback) => {
  const elementRef = useRef();

  const handleClickOutside = (event) => {
    if (elementRef.current && !elementRef.current.contains(event.target)) {
      callback();
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return { elementRef }
}

export default useClickOutside;
